export default "__VITE_ASSET__D2WoSBq1__"